import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import { FORM_MODIFICACION_FUMIGADO_SILOS } from '../../../config/forms'
import { OperacionesModificacionFumigadoSiloDialogView } from '../components/OperacionesModificacionFumigadoSiloDialogView'

class OperacionesModificacionFumigadoSiloDialog extends Component {
  render () {
    const { silo } = this.props
    return (
      <OperacionesModificacionFumigadoSiloDialogView
        silo={silo}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    silo: state.movimientoSilos.siloOperando
  }
}
export default connect(mapStateToProps)(reduxForm({
  form: FORM_MODIFICACION_FUMIGADO_SILOS,
  initialValues: {},
  enableReinitialize: true
})(OperacionesModificacionFumigadoSiloDialog))
